import type {offerTemplateNotesRouteApi} from "./-route-api";
import {z} from "zod";

// Aggregate-backed Notes use local presentation state, never a new server list query.
export const offerTemplateNotesSearchSchema = z.object({
  page: z.number().int().min(1).catch(1),
  perPage: z.number().int().min(1).max(100).catch(10),
  q: z.string().optional().catch(undefined),
  sortBy: z.enum(["title", "content", "editedAt"]).catch("title"),
  sortDir: z.enum(["asc", "desc"]).catch("asc"),
});
export type OfferTemplateNotesSearch = z.output<typeof offerTemplateNotesSearchSchema>;
export type OfferTemplateNotesNavigateFn = ReturnType<
  typeof offerTemplateNotesRouteApi.useNavigate
>;
